module.exports = __webpack_public_path__ + "img/1588298583.08fd0e71.jpg";